import { render, staticRenderFns } from "./paperBag.vue?vue&type=template&id=c7583560&scoped=true&"
import script from "./paperBag.vue?vue&type=script&lang=js&"
export * from "./paperBag.vue?vue&type=script&lang=js&"
import style0 from "./paperBag.vue?vue&type=style&index=0&id=c7583560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7583560",
  null
  
)

export default component.exports